import { render, staticRenderFns } from "./memberMulImportRegion.vue?vue&type=template&id=235ec25a&scoped=true&"
import script from "./memberMulImportRegion.vue?vue&type=script&lang=js&"
export * from "./memberMulImportRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ec25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235ec25a')) {
      api.createRecord('235ec25a', component.options)
    } else {
      api.reload('235ec25a', component.options)
    }
    module.hot.accept("./memberMulImportRegion.vue?vue&type=template&id=235ec25a&scoped=true&", function () {
      api.rerender('235ec25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberMulImportRegion.vue"
export default component.exports